import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';

export default function TopContentCard({ content = [], siteConfig }) {
  const contentLabel = siteConfig?.contentLabel || 'Pages';

  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800 p-4 sm:p-5 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-slate-900 dark:text-white flex items-center gap-1.5">
            <FileText className="w-4 h-4 text-blue-500" />
            Top {contentLabel}
          </h3>
          <p className="text-[11px] text-slate-500 dark:text-slate-400">
            Leaderboard by views and engagement
          </p>
        </div>
      </div>

      {content.length === 0 ? (
        <div className="py-6 text-center text-xs text-slate-400">
          No content views recorded in this timeframe.
        </div>
      ) : (
        <div className="divide-y divide-slate-100 dark:divide-slate-800">
          {content.slice(0, 10).map((item, idx) => {
            const path = item.path || '/';
            // Pretty label from path
            const displayLabel = path === '/' ? 'Home (/)' : path.split('/').filter(Boolean).pop()?.replace(/-/g, ' ') || path;

            return (
              <div key={idx} className="py-2 flex items-center justify-between gap-3 text-xs">
                <div className="min-w-0 flex-1">
                  <div className="font-medium text-slate-900 dark:text-slate-100 truncate flex items-center gap-1">
                    <span className="truncate capitalize">{displayLabel}</span>
                    {siteConfig?.domain && path !== '/' && (
                      <a
                        href={`https://${siteConfig.domain}${path}`}
                        target="_blank"
                        rel="noreferrer"
                        className="text-slate-400 hover:text-blue-500 flex-shrink-0"
                      >
                        <ExternalLink className="w-3 h-3" />
                      </a>
                    )}
                  </div>
                  <div className="text-[10px] text-slate-400 font-mono truncate">{path}</div>
                </div>
                <div className="text-right flex-shrink-0 flex items-center gap-3">
                  <div>
                    <div className="font-mono font-bold text-slate-900 dark:text-white tabular-nums">
                      {Number(item.views || 0).toLocaleString()}
                    </div>
                    <div className="text-[10px] text-slate-400">views</div>
                  </div>
                  {Number(item.actions || 0) > 0 && (
                    <div className="px-1.5 py-0.5 rounded bg-emerald-50 dark:bg-emerald-950/60 border border-emerald-200 dark:border-emerald-800 text-[10px] font-mono text-emerald-700 dark:text-emerald-300">
                      {item.actions} act
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
